import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset } from '@fortawesome/free-solid-svg-icons';

import MyGate from './MyGate';
import Contact from './Contact';
import SupportTeam from './SupportTeam';

import './Support.css';

const Support = () => {
  return (
    <Container className="mt-4 ps-0 pe-0">
      <div className="support-header mb-4">
        <div className="d-flex align-items-center">
          <FontAwesomeIcon icon={faHeadset} className="support-icon me-2" />
          <div>
            <h2 className="mb-0">Support</h2>
            <p className="text-muted mb-0 mt-2">
              Get help and connect with our support team
            </p>
          </div>
        </div>
      </div>

      {/* MyGate Section */}
      <MyGate />

      {/* Support Team Section */}
      <SupportTeam />

      {/* Contact Section */}
      <Contact />
    </Container>
  );
};

export default Support;
